import { useState, useEffect } from 'react';
import { getPrimaryLocation, BusinessLocation, initializeDefaultLocations } from '../firebase/services/locationService';

export const usePrimaryLocation = () => {
  const [primaryLocation, setPrimaryLocation] = useState<BusinessLocation | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPrimaryLocation = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // First try to get the primary location
        let location = await getPrimaryLocation();
        
        // If no primary location exists, initialize default locations and try again
        if (!location) {
          console.log('No primary location found, initializing default locations...');
          await initializeDefaultLocations();
          location = await getPrimaryLocation();
        }
        
        setPrimaryLocation(location);
      } catch (err) {
        console.error('Error fetching primary location:', err);
        setError('Failed to load location information');
      } finally {
        setLoading(false);
      }
    };

    fetchPrimaryLocation();
  }, []);

  return {
    primaryLocation,
    loading,
    error,
    refetch: () => {
      const fetchPrimaryLocation = async () => {
        try {
          setLoading(true);
          setError(null);
          
          // First try to get the primary location
          let location = await getPrimaryLocation();
          
          // If no primary location exists, initialize default locations and try again
          if (!location) {
            console.log('No primary location found, initializing default locations...');
            await initializeDefaultLocations();
            location = await getPrimaryLocation();
          }
          
          setPrimaryLocation(location);
        } catch (err) {
          console.error('Error fetching primary location:', err);
          setError('Failed to load location information');
        } finally {
          setLoading(false);
        }
      };
      fetchPrimaryLocation();
    }
  };
}; 